import { createElement, lazy } from "react";
import { Outlet } from "react-router";
import type { FuseRouteItemType } from "@fuse/utils/FuseUtils";
import { criarRotaProtegida } from "./criarRotaProtegida";
import { APP_ROUTES } from "./app-rotas.constants";

// ------------------------------- CONSTANTS -------------------------------
/**
 * Definição das rotas do React Router para a aplicação. Arvore de rotas que define os caminhos, componentes e hierarquia de navegação para cada funcionalidade da aplicação.
 */
export const APP_ROUTE_ITEMS: FuseRouteItemType[] = [
	criarRotaProtegida(
		APP_ROUTES.financeiro.assistentePagamentos,
		() =>
			import(
				"@/app/(protected)/apps/financeiro/contas-a-pagar/assistente-pagamentos/components/assistente-pagamentos.view"
			),
	),
	{
		path: APP_ROUTES.produtos.base,
		element: createElement(Outlet),
		children: [
			criarRotaProtegida(
				APP_ROUTES.produtos.cadastroProdutos,
				() => import("@/app/(protected)/apps/produtos/cadastro-produtos/CadastroProdutos.route"),
			),
		],
	},
	{
		path: APP_ROUTES.config.base,
		element: createElement(Outlet),
		children: [
			{
				path: APP_ROUTES.config.conta.path,
				element: createElement(
					lazy(() => import("@/app/(protected)/conta/components/configuracoes/conta-configs.view")),
				),
				//Rota tudo liberado
			},
		],
	},
	{
		path: APP_ROUTES.configGeral.base,
		element: createElement(Outlet),
		children: [
			criarRotaProtegida(
				APP_ROUTES.configGeral.restricoes,
				() =>
					import(
						"@/app/(protected)/apps/configuracoes-gerais/components/cadastro-restricoes/CadastroRestricoes.view"
					),
			),
			criarRotaProtegida(
				APP_ROUTES.configGeral.integracaoIA,
				() => import("@/app/(protected)/apps/configuracoes-gerais/components/integracao-ia/IntegracaoIA.view"),
			),
		],
	},
	{
		path: APP_ROUTES.compras.base,
		element: createElement(Outlet),
		children: [
			criarRotaProtegida(
				APP_ROUTES.compras.compraInteligente,
				() => import("@/app/(protected)/apps/compras/components/compra-inteligente/CompraInteligente.view"),
			),
			criarRotaProtegida(
				APP_ROUTES.compras.prePedido,
				() => import("@/app/(protected)/apps/compras/components/pre-pedido/PrePedido.view"),
			),
			criarRotaProtegida(
				APP_ROUTES.compras.notasFiscaisEntrada,
				() =>
					import(
						"@/app/(protected)/apps/compras/components/notas-fiscais-entrada/notas-fiscais-entrada.view"
					),
			),
		],
	},
	{
		path: APP_ROUTES.vendas.base,
		element: createElement(Outlet),
		children: [
			criarRotaProtegida(
				APP_ROUTES.vendas.emissaoFiscal,
				() => import("@/app/(protected)/apps/vendas/emissao-fiscal/components/emissao-fiscal.view"),
			),
		],
	},
	{
		path: APP_ROUTES.analises.base,
		element: createElement(Outlet),
		children: [
			criarRotaProtegida(
				APP_ROUTES.analises.relatorio,
				() => import("@/app/(protected)/apps/relatorios/components/visualization/relatorios.view"),
			),
			criarRotaProtegida(
				APP_ROUTES.analises.dashboard,
				() =>
					import(
						"@/app/(protected)/apps/relatorios/components/dashboard/contas-a-pagar/dash-contasPagar.view"
					),
			),
		],
	},
	{
		path: APP_ROUTES.gestao.base,
		element: createElement(Outlet),
		children: [
			criarRotaProtegida(
				APP_ROUTES.gestao.powerbi,
				() => import("@/app/(protected)/apps/gestao/powerbi/components/gestao.view"),
			),
		],
	},
	{
		path: APP_ROUTES.financeiro.base,
		element: createElement(Outlet),
		children: [
			{
				path: APP_ROUTES.financeiro.contasPagar.path,
				element: createElement(Outlet),
				children: [
					criarRotaProtegida(
						APP_ROUTES.financeiro.contasPagarTitulos,
						() =>
							import(
								"@/app/(protected)/apps/financeiro/contas-a-pagar/titulos-pagar/components/titulos-pagar.view"
							),
					),
					criarRotaProtegida(
						APP_ROUTES.financeiro.contasPagarRequisicoes,
						() =>
							import(
								"@/app/(protected)/apps/financeiro/contas-a-pagar/requisicoes-despesas/components/requisicoes-despesas.view"
							),
					),
				],
			},
			criarRotaProtegida(
				APP_ROUTES.financeiro.assinaturaEletronica,
				() =>
					import(
						"@/app/(protected)/apps/financeiro/assinatura-eletronica/components/assinaturaEletronica.view"
					),
			),
		],
	},
];
